import React, { useRef } from 'react';
// import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { Button, CircularProgress, Paper, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import TitleToolbar from "../../Forms/TitleToolbar";
import { periodsActions } from "../../../actions/periodsActions";
import EMTable from "../../Tables/EMTable";
import CellTextTable from "../../Tables/CellTextTable";
import {
    pageModes,
    styleWithCommonClasses,
    tabDisplays,
} from '../../../_constants/emparkConstants';
import translate from '../../../locales';
import { periodsService } from '../../../services';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ErrorPeriodShortStayOverlap from '../../Dialogs/ErrorPeriodShortStayOverlap';

const __t = translate;

const finalValues = (props) => {
    return props.type == 'groups' ? props.groups : props.emissionProfiles;
}

const styles = styleWithCommonClasses({});

const PeriodChildListPage = props => {
    useEffect(() => {
        props.fetchValues(props.rateId, props.periodId, props.type);
    }, [props.type, props.periodId]);

    const valuesState = finalValues(props);

    if (valuesState.loading) {
        return (
            <Paper
                className={props.classes.paperNoMargins}
                elevation={0}
            >
                <TitleToolbar
                    title={`${__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}`}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress color="secondary" />
                    </div>
                </TitleToolbar>
            </Paper>
        )
    }

    if (valuesState.error) {
        return (
            <Paper
                className={props.classes.paperNoMargins}
                elevation={0}
            >
                <TitleToolbar
                    title={`${__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}`}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <strong>{__t(props.type == 'groups' ? 'error_fetch_groups' : 'error_fetch_emission_profiles')}</strong>
                    </div>
                </TitleToolbar>
            </Paper>
        )
    }

    return (
        <PeriodChildList
            rateId={props.rateId}
            periodId={props.periodId}
            type={props.type}
            values={valuesState.values ? valuesState.values : []}
            router={props.router}
            changeMode={props.changeMode}
            changeTabDisplay={props.changeTabDisplay}
            updateValues={props.updateValues}
        />
    )
}

const PeriodChildList = props => {
    const tableSubmitRef = useRef();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorPositionOverlap, setErrorPositionOverlap] = useState(null);

    // const [errorPositionOverlap, setErrorPositionOverlap] = useState(null);
    // const [errorPositionOverlap, setErrorPositionOverlap] = useState([
    //     {
    //         rateId: 1,
    //         rateName: "Rate 1",
    //         period: {
    //             fromDate: '2025-01-01',
    //             toDate: '2025-12-31'
    //         },
    //         type: 'GROUPS',
    //         positions: ["POS 1", "POS 2", "POS 3", "POS 4", "POS 5", "POS 6", "POS 7", "POS 8", "POS 9", "POS 10", "POS 11", "POS 12", "POS 13", "POS 14", "POS 15"],
    //         auxValues: ["Group A", "Group B", "Group C", "Group E", "Group F", "Group G", "Group H", "Group I", "Group J", "Group K", "Group L"]
    //     },
    //     {
    //         rateId: 1,
    //         rateName: "Rate 2",
    //         period: {
    //             fromDate: '2025-01-01',
    //             toDate: '2025-12-31'
    //         },
    //         type: 'GROUPS',
    //         positions: ["POS 4", "POS 2", "POS 3"],
    //         auxValues: ["Group A", "Group B", "Group D"]
    //     },
    //     {
    //         rateId: 1,
    //         rateName: "Rate 3",
    //         period: {
    //             fromDate: '2025-01-01',
    //             toDate: '2025-12-31'
    //         },
    //         type: 'GROUPS',
    //         positions: ["POS 4", "POS 2", "POS 3"],
    //         auxValues: ["Group A", "Group B", "Group D"]
    //     }
    // ]);

    if (props.router.mode === pageModes.edit) {
        return (
            <Paper
                // className={classes.paperNoMargins}
                elevation={0}
            >
                <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <TitleToolbar
                        title={`${__t('edit')} ${__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}`}
                        onCancel={() => {
                            props.changeTabDisplay(tabDisplays.index);
                            props.changeMode(pageModes.view);
                        }}
                        onSave={async () => {
                            if (!tableSubmitRef.current) {
                                console.error('no reference set to table');
                                return;
                            }

                            const finalValues = tableSubmitRef.current();

                            setIsSubmitting(true);
                            try {
                                let response = null;
                                if (props.type === 'groups') {
                                    response = await periodsService.savePeriodGroups(props.rateId, props.periodId, finalValues);
                                }
                                else {
                                    response = await periodsService.savePeriodEmissionProfiles(props.rateId, props.periodId, finalValues);
                                }

                                console.log('Response after submitting values', response);

                                setIsSubmitting(false);
                                if (response.status == 200) {
                                    props.updateValues(props.rateId, props.periodId, props.type, finalValues);
                                    return;
                                } else if (response.status == 409) {
                                    const jsonResponse = await response.json();
                                    if (jsonResponse) {
                                        setErrorPositionOverlap(jsonResponse);
                                        return;
                                    }
                                }

                                console.error('Error while submitting values', response);
                            } catch (e) {
                                console.error('Error while submitting values. Response: ', e);
                                setIsSubmitting(false);
                            }
                        }}
                    >
                        <CellTextTable
                            refReturnData={(returnData) => { tableSubmitRef.current = returnData }}
                            values={props.values}
                            type="text"
                        />
                    </TitleToolbar>
                </div>
                <Dialog
                    open={isSubmitting}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogContent>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress color="secondary" />
                        </div>
                    </DialogContent>
                </Dialog>
                <ErrorPeriodShortStayOverlap
                    overlapPeriodSs={errorPositionOverlap}
                    onOkClick={() => setErrorPositionOverlap(null)}
                />
            </Paper>
        )
    }

    const values = props.values.map((v, i) => ({ val: v, id: i }));
    return (
        <Paper
            // className={classes.paperNoMargins}
            elevation={0}
        >
            <div style={{ paddingLeft: '10px' }}>
                <EMTable
                    tableTitle={__t(props.type == 'groups' ? 'groups' : 'emission_profiles')}
                    dataSource={values}
                    rows={[
                        { id: 'val', align: 'center', disablePadding: false, label: '' }
                    ]}
                    customTableButton={
                        <Button
                            style={{ marginRight: '15px' }}
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                props.changeTabDisplay(tabDisplays.secondary)
                                props.changeMode(pageModes.edit)
                            }}
                        >
                            {__t('edit')}
                        </Button>
                    }
                />
            </div>
        </Paper>
    );
}

function mapStateToProps(state) {
    return {
        groups: state.periodsReducer.periodGroups,
        emissionProfiles: state.periodsReducer.periodEmissionProfiles,
        router: state.periodsReducer.periodPositionsRouter,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchValues: (rateId, periodId, type) => {
            if (type === 'groups') {
                dispatch(periodsActions.fetchGroups(rateId, periodId));
            }
            else {
                dispatch(periodsActions.fetchEmissionProfiles(rateId, periodId));
            }
        },
        updateValues: (rateId, periodId, type, values) => {
            if (type === 'groups') {
                dispatch(periodsActions.updateGroups(rateId, periodId, values));
            }
            else {
                dispatch(periodsActions.updateEmissionProfiles(rateId, periodId, values));
            }
        },
        changeMode: (mode) => {
            dispatch(periodsActions.changeModePeriodPositions(mode))
        },
        changeTabDisplay: (tabDisplay) => {
            dispatch(periodsActions.setTabDisplay(tabDisplay))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PeriodChildListPage));